import { inject as b, defineComponent as g, ref as d, onBeforeMount as R, onMounted as k, openBlock as m, createElementBlock as A } from "vue";
const _ = "https://www.google.com/recaptcha/api.js", E = "https://recaptcha.net/recaptcha/api.js", p = "vue3-recaptcha-v2:options", h = "vue3-recaptcha-v2", s = typeof window > "u";
class a extends Error {
  constructor(t) {
    super(t), this.message = "[vue3-recaptcha-v2] " + t;
  }
}
const x = () => {
  const n = b(p);
  return {
    options: n,
    handleGenerateScript: (r) => {
      if (s)
        throw new a("Cannot generate script on server side");
      const e = document.createElement("script"), c = n != null && n.cnDomains ? E : _, i = r ? `&hl=${r}` : "";
      e.setAttribute("id", h), e.setAttribute("src", `${c}?render=explicit${i}`), e.setAttribute("async", ""), e.setAttribute("defer", ""), e.onerror = () => {
        new a("Failed to load script");
      }, document.head.appendChild(e);
    }
  };
}, S = () => ({
  handleReset: (e) => {
    if (s)
      throw new a("reCaptcha is not available on server side");
    if (!window.grecaptcha)
      throw new a("reCaptcha is not available on window");
    window.grecaptcha.reset(e);
  },
  handleGetResponse: (e) => {
    if (s)
      throw new a("reCaptcha is not available on server side");
    if (!window.grecaptcha)
      throw new a("reCaptcha is not available on window");
    return window.grecaptcha.getResponse(e);
  },
  handleExecute: (e) => {
    if (s)
      throw new a("reCaptcha is not available on server side");
    if (!window.grecaptcha)
      throw new a("reCaptcha is not available on window");
    window.grecaptcha.execute(e);
  }
}), y = /* @__PURE__ */ g({
  __name: "Recaptcha",
  props: {
    theme: {},
    size: {},
    tabindex: {},
    language: {}
  },
  emits: ["widgetId", "loadCallback", "expiredCallback", "errorCallback"],
  setup(n, { emit: t }) {
    const r = n, e = d(null), c = d(null), { handleGenerateScript: i, options: w } = x(), u = () => {
      if (!window.grecaptcha)
        throw new a("reCAPTCHA is not loaded");
      if (!c.value)
        throw new a("element is not defined");
      window.grecaptcha.ready(() => {
        try {
          const { sitekey: o } = w, { theme: l, size: C, tabindex: f } = r;
          e.value = window.grecaptcha.render(c.value, {
            sitekey: o,
            theme: l,
            size: C,
            tabindex: f,
            callback: (v) => t("loadCallback", v),
            "expired-callback": () => t("expiredCallback"),
            "error-callback": () => t("errorCallback")
          }), t("widgetId", e.value);
        } catch (o) {
          throw new a(o.message);
        }
      });
    };
    return R(() => {
      i(r.language);
    }), k(() => {
      document.getElementById(h).onload = () => {
        u();
      };
    }), (o, l) => (m(), A("div", {
      ref_key: "reCAPTCHARef",
      ref: c
    }, null, 512));
  }
});
function G(n, t) {
  if (!t.sitekey)
    throw new a("sitekey is required");
  n.provide(p, t);
}
export {
  y as RecaptchaV2,
  G as install,
  S as useRecaptcha
};
